<template>
  <div>
    <v-menu
      ref="menu1"
      v-model="menu1"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="itemActivo.Fecha"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          append-icon="event"
          :label="label"
          :value="iFecha"
          :rules="rules"
          :readonly="true"
          clearable
          @click:clear="limpiarValor"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="itemActivo.Fecha"
        no-title
        scrollable
        format="dd/mm/yyyy"
        locale="es-AR"
        :min="itemActivo.FechaMinima"
        :max="itemActivo.FechaMaxima"
        :readonly="readonly"
        :first-day-of-week="1"
        @input="seleccionarItem"
      >
        <v-spacer></v-spacer>
        <v-btn small text rounded @click="menu1 = false">
          Cancelar
          <v-icon right>clear</v-icon>
        </v-btn>
        <v-btn small rounded color="primary" @click="seleccionarItem">
          Aceptar
          <v-icon right>check</v-icon>
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";
export default {
  name: "Fecha",
  props: {
    label: String,
    fecha: String,
    item: {},
    rules: {},
    readonly: Boolean,
    sinFechaMinima: Boolean,
    sinFechaMaxima: Boolean
  },
  data() {
    return {
      itemActivo: {
        Fecha: "",
        FechaMinima: "",
        FechaMaxima: ""
      },
      // 1945-04-26
      //new Date().toISOString().substr(0, 10)
      menu1: false
    };
  },
  computed: {
    iFecha: {
      get() {
        return this.itemActivo.Fecha
          ? moment(this.itemActivo.Fecha)
              .locale("es-AR")
              .format("L")
          : "";
      },
      set(valor) {
        this.itemActivo.Fecha = valor;
        this.seleccionarItem();
      }
    }
  },
  watch: {
    fecha(valor) {
      if (valor != undefined) this.itemActivo.Fecha = valor;
    }
  },
  created() {
    eventBus.$on("inicializarFecha", this.inicializar);
    this.inicializar();
  },
  mounted() {
    this.seleccionarItem();
  },
  beforeDestroy() {
    eventBus.$off("inicializarFecha", this.inicializar);
  },
  methods: {
    inicializar() {
      this.itemActivo.Fecha =
        this.fecha == "" ? new Date().toJSON() : this.fecha;
      this.itemActivo.FechaMinima = this.sinFechaMinima
        ? new Date().toJSON()
        : new Date("1945-04-25").toJSON();
      this.itemActivo.FechaMaxima = this.sinFechaMaxima
        ? null
        : new Date().toJSON();
      this.$emit("seleccionarItem", this.itemActivo, this.item);
    },
    seleccionarItem() {
      this.$refs.menu1.save(this.itemActivo.Fecha);
      this.$emit("seleccionarItem", this.itemActivo, this.item);
    },
    limpiarValor() {
      this.itemActivo.Fecha = null;
      this.seleccionarItem();
    }
  }
};
</script>
